import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  const menuItems = {
    'Aracınız İçin': [
      { name: 'Trafik Sigortası', link: '/trafik-sigortasi' },
      { name: 'Kasko', link: '/kasko' },
      { name: 'Yol Yardım Sigortası', link: '/yol-yardim-sigortasi', comingSoon: true },
      { name: 'İhtiyari Mali Mesuliyet (İMM)', link: '/imm-sigortasi', comingSoon: true }
    ],
    'Eviniz İçin': [
      { name: 'DASK', link: '/dask', comingSoon: true },
      { name: 'Konut Sigortası', link: '/konut-sigortasi', comingSoon: true }
    ],
    'Sağlığınız İçin': [
      { name: 'Tamamlayıcı Sağlık Sigortası', link: '/tamamlayici-saglik-sigortasi' },
      { name: 'Özel Sağlık Sigortası', link: '/ozel-saglik-sigortasi', comingSoon: true },
      { name: 'Seyahat Sağlık Sigortası', link: '/seyahat-saglik-sigortasi', comingSoon: true },
      { name: 'Yabancı Sağlık Sigortası', link: '/yabanci-saglik-sigortasi', comingSoon: true },
      { name: 'Ferdi Kaza', link: '/ferdi-kaza-sigortasi' }
    ],
    'Kurumsal Çözümler': [
      { name: 'İşyeri Sigortası', link: '/isyeri-sigortasi', comingSoon: true },
      { name: 'İnşaat All Risk Sigortası', link: '/insaat-all-risk-sigortasi', comingSoon: true },
      { name: 'Nakliyat Sigortası', link: '/nakliyat-sigortasi', comingSoon: true }
    ],
    'Destek': [
      { name: 'Hakkımızda', link: '/hakkimizda' }
    ]
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setActiveMenu(null);
  };

  return (
    <nav className="bg-white white-b">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex-shrink-0 md:pl-12" onClick={handleLinkClick}>
            <img
              src="/why/sigortamolsun.png"
              alt="sigortamolsun"
              className="h-4 md:h-8"
            />
          </Link>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          <div className="hidden md:flex md:items-center md:space-x-8">
            {Object.entries(menuItems).map(([title, items]) => (
              <div
                key={title}
                className={`relative group ${title === 'Destek' ? 'last:ml-4' : ''}`}
                onMouseEnter={() => setActiveMenu(title)}
                onMouseLeave={() => setActiveMenu(null)}
              >
                <button 
                  className={`${
                    title === 'Destek' 
                      ? 'border-2 border-blue-500 text-blue-500 px-4 py-2 rounded-lg hover:bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 px-3 py-2'
                  }`}
                >
                  {title}
                </button>
                {activeMenu === title && (
                  <div className="absolute top-full left-0 w-64 bg-white border rounded-lg shadow-lg z-50">
                    <div className="absolute top-0 left-0 w-full h-2 bg-transparent -translate-y-2"></div>
                    {items.map((item) => (
                      item.comingSoon ? (
                        <div
                          key={item.name}
                          className="relative block px-4 py-2 text-sm cursor-default"
                        >
                          <span className="text-gray-400">{item.name}</span>
                          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xs font-medium text-blue-500 bg-blue-50 px-2 py-0.5 rounded">
                            Yakında
                          </span>
                        </div>
                      ) : (
                        <Link
                          key={item.name}
                          to={item.link}
                          onClick={handleLinkClick}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {item.name}
                        </Link>
                      )
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden">
            {Object.entries(menuItems).map(([title, items]) => (
              <div key={title} className="px-2 pt-2 pb-3">
                <button
                  className={`w-full text-left px-3 py-2 ${
                    title === 'Destek' 
                      ? 'text-blue-500'
                      : 'text-gray-600'
                  }`}
                  onClick={() => setActiveMenu(activeMenu === title ? null : title)}
                >
                  {title}
                </button>
                {activeMenu === title && (
                  <div className="pl-4">
                    {items.map((item) => (
                      item.comingSoon ? (
                        <div
                          key={item.name}
                          className="relative block px-3 py-2 text-sm cursor-default"
                        >
                          <span className="text-gray-400">{item.name}</span>
                          <span className="ml-2 inline-block text-xs font-medium text-blue-500 bg-blue-50 px-2 py-0.5 rounded">
                            Yakında
                          </span>
                        </div>
                      ) : (
                        <Link
                          key={item.name}
                          to={item.link}
                          onClick={handleLinkClick}
                          className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          {item.name}
                        </Link>
                      )
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;